// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"170b1f77","453":"1eee60aa","667":"2c732028"}[chunkId] + ".chunk.js";
};